/**
   @function checkIfAuthenticatedAndAuthenticate
   function checkes if user is authenticated and if not authenticates it
   @param {function} loginFunction - function used for login 
   @param {boolean} isAuthenticated - boolean rappresenting authentication status
   @param {boolean} isLoading - boolean rappresentig authentication flow status
   @returns {none}
*/

export default function checkIfAuthenticatedAndAuthenticate(
  loginFunction: () => void,
  isAuthenticated: boolean,
  isLoading: boolean
) {
  if (!isAuthenticated && !isLoading) loginFunction();
}
